export default __webpack_public_path__ + "static/Hong-Kong-Tennis-&-Golf-academy-f2ff4b7e32c663bf57d02729c6e1829b.svg";